import React from "react";
import { Skeleton } from "antd";
import { ImCheckboxChecked } from "react-icons/im";

const CategoryCards = ({
  data,
  SubCategorySkeletonArray,
  SkeletonLoad,
  SelectedSubCategoryData,
  getAllProducts,
  setSubCategoryName,
}) => {
  return (
    <div className="w-full min-w-0 px-4 md:px-10 lg:px-16 xl:px-20">
      {SkeletonLoad ? (
        <div className="flex flex-wrap justify-center gap-4 my-8">
          {SubCategorySkeletonArray.map((index) => (
            <div
              key={index}
              className="relative flex w-[120px] justify-center md:w-[140px]"
            >
              <Skeleton.Avatar
                active={true}
                style={{ height: 88, width: 88 }}
                shape={"circle"}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-5 py-6">
          {data.map((el, i) => (
            <button
              type="button"
              key={i}
              onClick={() => {
                getAllProducts(el.slug);
                setSubCategoryName({ name: el.title, slug: el.slug });
              }}
              className="flex w-[120px] min-w-0 flex-col items-center justify-start bg-white md:w-[140px]"
            >
              <div className="relative">
                <img
                  src={process.env.REACT_APP_HAPS_MEDIA_BASE_URL + el.image}
                  alt={el.title || "Subcategory"}
                  className={`h-20 w-20 rounded-full object-contain transition-transform duration-300 md:h-24 md:w-24 ${
                    SelectedSubCategoryData === el.slug
                      ? "border-4 border-[#027100]"
                      : "border-4 border-transparent hover:scale-105"
                  }`}
                />
                {SelectedSubCategoryData === el.slug && (
                  <ImCheckboxChecked
                    size={20}
                    className="absolute right-0 top-0 rounded-full border-2 border-[#027100] bg-[#027100] text-[#ffe342]"
                  />
                )}
              </div>
              <span
                className={`mt-2 w-full break-words text-center text-xs font-bold capitalize md:text-sm ${
                  SelectedSubCategoryData === el.slug
                    ? "text-[#027100]"
                    : "text-black"
                }`}
              >
                {el.title || ""}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryCards;
